/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	init: (app) => {

		/*
		|
		| Automatic step circle
		|--------------
		*/
		let items = document.querySelectorAll('.circle-step-box .step-item');
		for (let i = 0, l = items.length; i < l; i++) {
			items[i].style.left = (48 - 35 * Math.cos(-0.5 * Math.PI - 2 * (1 / l) * i * Math.PI)).toFixed(4) + "%";
			items[i].style.top = (48 + 35 * Math.sin(-0.5 * Math.PI - 2 * (1 / l) * i * Math.PI)).toFixed(4) + "%";
		}

		let timer = 5000

		$('.circle-step-box .cercle').css({ 'animation-duration': (timer / 1000) + 's' })

		$('.step-item').click(function () {
			$('.step-item.active').toggleClass('active', false)

			$(this).toggleClass('active', true)

			clearInterval(interval)
			interval = setInterval(nextItem, timer)
		})

		let interval = setInterval(nextItem, timer)

		function nextItem() {
			let $active = $('.step-item.active'),
				$next = $active.next('.step-item')

			if ($next.length == 0) {
				$next = $('.circle-step-box .step-item').first()
			}

			$active.toggleClass('active', false)
			$next.toggleClass('active', true)
		}
	}
}

